import { render } from "./startOnBoard.vue?vue&type=template&id=20ead0f3&scoped=true&ts=true"
import script from "./startOnBoard.vue?vue&type=script&lang=ts"
export * from "./startOnBoard.vue?vue&type=script&lang=ts"

import "./startOnBoard.vue?vue&type=style&index=0&id=20ead0f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ead0f3"]])

export default __exports__